import { Stack } from '@mui/material';
import { OptionsTable } from './OptionsTable';

export function TelematicsBoxOptions() {
  return (
    <Stack direction="row" spacing={1} sx={{ p: 1 }}>
      <title>IR3 | Telematics Box Options</title>
      <OptionsTable name="telematicsBoxType" title="Types" />
    </Stack>
  );
}
